import { render, staticRenderFns } from "./PlayerZone.vue?vue&type=template&id=3663e3ae&scoped=true&"
import script from "./PlayerZone.vue?vue&type=script&lang=js&"
export * from "./PlayerZone.vue?vue&type=script&lang=js&"
import style0 from "./PlayerZone.vue?vue&type=style&index=0&id=3663e3ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3663e3ae",
  null
  
)

export default component.exports